export default ({...props}) => {
  const {space, size} = props.theme
  return `
      display: flex;
      flex-flow: column;
      justify-content: center;
      align-items: center;
      width: ${size(12.5)}%;
      height: ${size(12.5)}%;
      padding: ${space(2.5)}px;
      gap: ${space(2)}px;

      & > div:nth-of-type(2) {
        text-align: center;
      }

      @media screen and (max-width: 601px) {
        width: calc(${size(12.5)}vw - ${size(5)}px);
        height: calc(${size(12.5)}vh - ${size(5)}px);
      }
    `
}
